<template>
  <v-container>
    <v-col
      cols="12"
      md="12"
      sm="12"
      v-if="operaciones.length === 0 && sinDatos"
    >
      <v-card flat>
        <div class="text-center mt-16 pt-16">
          <v-progress-circular
            :size="70"
            :width="7"
            color="green"
            indeterminate
          ></v-progress-circular>
          <h2>Cargando...</h2>
        </div>
      </v-card>
    </v-col>
    <div v-else v-for="(op, idx) in operaciones" :key="'operacion-' + idx">
      <operacion
        v-for="(detalle, idx2) in op.operacionesEnProgreso"
        :key="'op-' + idx + '-' + idx2"
        :operacion="op"
        :sesiones="sesiones"
        :area="area"
        :paros="paros"
        :paroTipos="paroTipos"
        :detalle="detalle"
        @change="actualizar"
        @update="paroActualizar"
      ></operacion>
    </div>
    <v-col cols="12" md="12" sm="12" v-if="operaciones.length == 0 && !sinDatos">
      <v-card flat>
        <div class="h2 text-center">
          No hay Operaciones en Progreso en Esta Área
        </div>
      </v-card>
    </v-col>
  </v-container>
</template>

<script>
import axios from "axios";
import operacion from "./Operacion";

export default {
  components: {
    operacion,
  },
  props: {
    area: {
      type: Object,
      default: () => ({
        area: "",
        idArea: -1,
        operacionesCurso: 0,
      }),
    },
  },
  data: () => ({
    operaciones: [],
    sesiones: [],
    paros: [],
    paroTipos: [],
    sinDatos: false,
  }),
  watch: {
    area: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.idArea > 0) {
         // console.log("Cargando operaciones para área:", newVal.idArea);
          this.getParoTipos();
          this.getOperaciones();
          this.getOperadores();
          this.getParos();
        }
      },
    },
  },
  methods: {
    actualizar() {
      this.getOperaciones();
      this.getOperadores();
      this.getParos();
    },
    getOperaciones() {
      this.sinDatos = true;
      axios
        .get("/ComandoYControl/OperacionesProgreso/" + this.area.idArea)
        .then((response) => {
        //  console.log("✅ getOperaciones:", response.data);
          this.operaciones = response.data || [];
        })
        .catch((error) => {
        //  console.error("❌ Error obteniendo operaciones:", error);
        })
        .finally(() => {
          this.sinDatos = false;
        });
    },
    getOperadores() {
      axios
        .get("/ComandoYControl/SesionesAbiertas/" + this.area.idArea)
        .then((r) => (this.sesiones = r.data))
        .catch((e) => console.error(e));
    },
    getParos() {
      axios
        .get("/ComandoYControl/Paros/" + this.area.idArea)
        .then((r) => (this.paros = r.data))
        .catch((e) => console.error(e));
    },
    getParoTipos() {
      axios
        .get("/ComandoYControl/ParoTipos")
        .then((r) => (this.paroTipos = r.data))
        .catch((e) => console.error(e));
    },
    paroActualizar() {
      this.getParos();
    },
  },
};
</script>